import { render, staticRenderFns } from "./CheckoutPopup.vue?vue&type=template&id=610e389c&"
import script from "./CheckoutPopup.vue?vue&type=script&lang=js&"
export * from "./CheckoutPopup.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports